// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const skorupi: PokeData = {
  "id": 451,
  "name": "skorupi",
  "height": 8,
  "weight": 120,
  "base_experience": 66,
  "types": [
    PokeType.POISON,
    PokeType.BUG
  ],
  "api_moves": [
    "swords-dance",
    "poison-sting",
    "pin-missile",
    "leer",
    "bite",
    "toxic",
    "scary-face",
    "pursuit",
    "crunch",
    "knock-off",
    "poison-fang",
    "acupressure",
    "toxic-spikes",
    "night-slash",
    "x-scissor",
    "cross-poison",
    "bug-bite",
    "hone-claws",
    "venoshock",
    "fell-stinger"
  ],
  "moves": [
    "pin-missile",
    "leer",
    "bite",
    "scary-face",
    "pursuit",
    "crunch",
    "poison-fang",
    "toxic-spikes",
    "night-slash",
    "bug-bite",
    "poison-jab",
    "infest",
    "bug-buzz"
  ],
  "evolution_chain": {
    "id": 234,
    "item": null,
    "species": [
      {
        "name": "skorupi",
        "order": 471,
        "types": [
          PokeType.POISON,
          PokeType.BUG
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "drapion",
        "order": 472,
        "types": [
          PokeType.POISON,
          PokeType.DARK
        ],
        "evolves_from_species_id": 451,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 40,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 56.25,
    "speed": 65,
    "ability_power": 50
  },
  "stat_changes": [],
  "catch_rate": 120,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
